import React, { useState, useEffect } from "react";
import {
  Tag,
  Table,
  Input,
  Select,
  Button,
  Form,
  Checkbox,
  message,
  Upload,
} from "antd";
import Layout from "Layout";
import { mixGetV1, mixPostV1, mixDelV1,mixPutV1 } from "services/mixin";
import {
  ReloadOutlined,
  PlusOutlined,
  SearchOutlined,
  CloseOutlined,
  SaveOutlined,
  UploadOutlined
} from "@ant-design/icons";

const { Option } = Select;
const { TextArea } = Input;

const ChatbotManager = () => {
  const [showForm, setShowForm] = useState(false);
  const [form] = Form.useForm();
  const [listTypeChats, setListTypeChats] = useState([]);
  const [listTypeBot, setListTypeBot] = useState([]);
  const [listChatbot, setListChatbot] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterCategory, setFilterCategory] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");
  const [fileList, setFileList] = useState([]);
  const [avatarPath, setAvatarPath] = useState("");
  const createSlug = (str) => {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
  };

  // const handleCancel = () => {
  //   setShowForm(false);
  //   form.resetFields();
  //   setIsEdit(false);
  //   setCurrentId(null);
  // };

  // const fetchChatbots = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await mixGetV1("/api/v1/be/model_chats");
  //     if (res?.status && res.data?.items) {
  //       setListChatbot(res.data.items);
  //     } else {
  //       message.warning("Không có dữ liệu chatbot!");
  //     }
  //   } catch (error) {
  //     message.error("Không thể tải danh sách chatbot!");
  //     console.error(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const uploadImage = async (file, name) => {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('name', name);
    
    const baseURL = 'https://aihub-api.buso.asia';
    
    const response = await fetch(`${baseURL}/api/v1/photo_library`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    
    return await response.json();
  };
  const fetchChatbots = async (categoryId = "all", status = "all") => {
    try {
      setLoading(true);

      let url = "/api/v1/be/model_chats?";
      const params = [];

      if (categoryId !== "all") {
        params.push(`model_chat_category_id=${categoryId}`);
      }
      if (status === "active") {
        params.push("is_active=1");
      } else if (status === "inactive") {
        params.push("is_active=0");
      }

      url += params.join("&");

      const res = await mixGetV1(url);
      if (res?.status && res.data?.items) {
        setListChatbot(res.data.items);
      } else {
        message.warning("Không có dữ liệu chatbot!");
      }
    } catch (error) {
      message.error("Không thể tải danh sách chatbot!");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchChatbots();
  }, []);

  useEffect(() => {
    const fetchTypeChats = async () => {
      try {
        const res = await mixGetV1("/api/v1/be/type_chats");
        if (res && res.data.items) {
          setListTypeChats(res.data.items);
        }
      } catch (error) {
        message.error("Không thể tải danh sách dịch vụ");
      }
    };
    fetchTypeChats();
  }, []);

  useEffect(() => {
    const fetchTypeBot = async () => {
      try {
        const res = await mixGetV1("/api/v1/be/model_chat_categories");
        if (res && res.data.items) {
          setListTypeBot(res.data.items);
        }
      } catch (error) {
        message.error("Không thể tải danh mục bot");
      }
    };
    fetchTypeBot();
  }, []);
  useEffect(() => {
    const fetchTypeBot = async () => {
      try {
        const res = await mixGetV1("/api/v1/be/model_chat_categories");
        if (res && res.data.items) {
          setListTypeBot(res.data.items);
        }
      } catch (error) {
        message.error("Không thể tải danh mục bot");
      }
    };
    fetchTypeBot();
  }, []);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        ...values,
        slug: createSlug(values.name),
        is_active: values.is_active ? 1 : 0,
        is_free: values.is_free ? 1 : 0,
        avatar: avatarPath ? avatarPath.replace(/^https?:\/\/[^/]+/, "") : "", 
      };

      let res;
      if (isEdit && currentId) {
        res = await mixPutV1(`/api/v1/be/model_chat/${currentId}`, payload);
      } else {
        res = await mixPostV1("/api/v1/be/model_chat", payload);
      }

      if (res?.status) {
        message.success(isEdit ? "Cập nhật thành công!" : "Thêm thành công!");
        handleCancel();
        fetchChatbots();
      } else {
        message.error("Thao tác thất bại!");
      }
    } catch (error) {
      message.error("Vui lòng nhập đầy đủ thông tin!");
      console.error(error);
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    form.resetFields();
    setIsEdit(false);
    setCurrentId(null);
    setFileList([]);
    setAvatarPath("");
  };

  const handleEdit = async (record) => {
    try {
      setIsEdit(true);
      setShowForm(true);
      setCurrentId(record.id);

      const res = await mixGetV1(`/api/v1/be/model_chat/${record.id}`);
      if (res?.status && res.data) {
        const data = res.data;
        form.setFieldsValue({
          ...data,
          is_active: data.is_active === 1,
          is_free: data.is_free === 1,
        });
        
        // Hiển thị avatar nếu có
        if (data.avatar) {
          setAvatarPath(data.avatar);
          setFileList([{
            uid: '-1',
            name: 'avatar',
            status: 'done',
            url: data.avatar,
          }]);
        }
      }
    } catch (error) {
      message.error("Lỗi khi tải dữ liệu!");
    }
  };


  const handleDelete = async (id) => {
    try {
      await mixDelV1(`/api/v1/be/model_chat/${id}`);
      message.success("Xóa chatbot thành công!");
      fetchChatbots();
    } catch (error) {
      message.error("Xóa thất bại!");
      console.error(error);
    }
  };

  const columns = [
    {
      title: "Tên Chatbot",
      dataIndex: "name",
      key: "name",
      render: (text) => <span className="font-medium">{text}</span>,
    },
    {
      title: "Dịch vụ",
      dataIndex: "type_chat_name",
      key: "type_chat_name",
    },
    {
      title: "Tên Model",
      dataIndex: "name_model",
      key: "name_model",
    },
    {
      title: "Danh mục bot",
      dataIndex: "model_chat_category_name",
      key: "model_chat_category_name",
    },
    {
      title: "Chi phí / 1K tokens",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Có phí",
      dataIndex: "is_free",
      key: "is_free",
      render: (val) =>
        val === 1 ? <Tag color="red">Có phí</Tag> : <Tag color="green">Miễn phí</Tag>,
    },
    {
      title: "Hoạt động",
      dataIndex: "is_active",
      key: "is_active",
      render: (val) =>
        val === 1 ? <Tag color="blue">Hoạt động</Tag> : <Tag color="gray">Không hoạt động</Tag>,
    },
    {
      title: "Thao tác",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <div className="flex justify-center gap-2">
          <Button type="primary" size="small" onClick={() => handleEdit(record)} className="bg-blue-500">
            Sửa
          </Button>
          <Button danger size="small" onClick={() => handleDelete(record.id)}>
            Xóa
          </Button>
        </div>
      ),
    },
  ];

  return (
    <Layout>
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="flex flex-wrap gap-3 items-center mb-4">
          <Input
            placeholder="Tìm kiếm theo tên hoặc model..."
            prefix={<SearchOutlined />}
            className="!w-[320px] h-10"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Select
            placeholder="Chọn danh mục bot"
            className="w-[200px] h-10"
            allowClear
            onChange={(value) => {
              setFilterCategory(value || "all");
              fetchChatbots(value || "all");
            }}
          >
            <Option value="all">Tất cả danh mục</Option>
            {listTypeBot.length > 0 ? (
              listTypeBot.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))
            ) : (
              <Option disabled>Đang tải...</Option>
            )}
          </Select>
          <Select
            placeholder="Chọn trạng thái"
            defaultValue="all"
            className="w-[200px] h-10"
            onChange={(value) => {
              setFilterStatus(value || "all");
              fetchChatbots(filterCategory, value || "all");
            }}
          >
            <Option value="all">Tất cả trạng thái</Option>
            <Option value="active">Hoạt động</Option>
            <Option value="inactive">Không hoạt động</Option>
          </Select>


          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="bg-blue-500 h-10 px-5"
            onClick={() => {
              setShowForm(true);
              setIsEdit(false);
              form.resetFields();
            }}
          >
            Thêm mới
          </Button>
        </div>

        {/* Form thêm/sửa chatbot */}
        {showForm && (
          <div className="mt-4 bg-blue-50 rounded-lg p-6 border border-blue-200">
            <div className="flex items-center gap-2 mb-4">
              <PlusOutlined className="text-blue-500 text-lg" />
              <h2 className="text-lg font-semibold">
                {isEdit ? "Chỉnh sửa Chatbot" : "Thêm Chatbot mới"}
              </h2>
            </div>

            <Form form={form} layout="vertical">
              <div className="grid grid-cols-2 gap-4">
                <Form.Item
                  label={<span className="font-medium">Tên Chatbot <span className="text-red-500">*</span></span>}
                  name="name"
                  rules={[{ required: true, message: "Vui lòng nhập tên chatbot" }]}
                >
                  <Input placeholder="VD: GPT-4, Claude 3, Gemini Pro..." size="large" className="rounded-lg" />
                </Form.Item>

                <Form.Item
                  label={<span className="font-medium">Dịch vụ <span className="text-red-500">*</span></span>}
                  name="type_chat_id"
                  rules={[{ required: true, message: "Vui lòng chọn dịch vụ" }]}
                >
                  <Select size="large" className="rounded-lg" placeholder="Chọn dịch vụ">
                    {listTypeChats.length > 0 ? (
                      listTypeChats.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>Đang tải...</Option>
                    )}
                  </Select>
                </Form.Item>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <Form.Item label="Tên Model" name="name_model">
                  <Input placeholder="VD: gpt-4, claude-3-opus..." size="large" className="rounded-lg" />
                </Form.Item>

                <Form.Item
                  label="Danh mục bot"
                  name="model_chat_category_id"
                  rules={[{ required: true, message: "Vui lòng chọn danh mục" }]}
                >
                  <Select size="large" className="rounded-lg" placeholder="Chọn danh mục">
                    {listTypeBot.length > 0 ? (
                      listTypeBot.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>Đang tải...</Option>
                    )}
                  </Select>
                </Form.Item>

                <Form.Item label="Chi phí / 1K tokens" name="price" initialValue="0">
                  <Input type="number" size="large" className="rounded-lg" />
                </Form.Item>
              </div>

              <Form.Item label="Mô tả" name="content">
                <TextArea placeholder="Mô tả về chatbot này..." rows={4} size="large" className="rounded-lg" />
              </Form.Item>
              <Form.Item
                label={<span className="font-medium">Avatar</span>}
                name="avatar"
              >
                <Upload
                  listType="picture-card"
                  fileList={fileList}
                  customRequest={async ({ file, onSuccess, onError }) => {
                    try {
                      console.log('Uploading:', file.name);
                      
                      const uploadRes = await uploadImage(file, file.name);
                      
                      console.log('Upload response:', uploadRes);
                      
                      if (uploadRes?.status === true && uploadRes.data?.image) {
                        const filePath = uploadRes.data.image;
                        setAvatarPath(filePath);
                        
                        setFileList([{
                          uid: file.uid,
                          name: file.name,
                          status: 'done',
                          url: filePath,
                        }]);
                        
                        message.success('Upload avatar thành công!');
                        onSuccess();
                      } else {
                        console.error('Upload failed:', uploadRes);
                        message.error('Upload thất bại, trùng slug!');
                        onError();
                      }
                    } catch (error) {
                      console.error('Upload error:', error);
                      message.error('Lỗi upload: ' + error.message);
                      onError(error);
                    }
                  }}
                  onRemove={() => {
                    setFileList([]);
                    setAvatarPath("");
                  }}
                  maxCount={1}
                  accept="image/*"
                >
                  {fileList.length === 0 && (
                    <div>
                      <UploadOutlined />
                      <div style={{ marginTop: 8 }}>Upload</div>
                    </div>
                  )}
                </Upload>
              </Form.Item>

              <div className="flex gap-6 mb-4">
                <Form.Item name="is_free" valuePropName="checked" className="mb-0">
                  <Checkbox>Có phí</Checkbox>
                </Form.Item>
                <Form.Item name="is_active" valuePropName="checked" initialValue={true} className="mb-0">
                  <Checkbox defaultChecked>Hoạt động</Checkbox>
                </Form.Item>
              </div>

              <div className="flex justify-end gap-3">
                <Button icon={<CloseOutlined />} onClick={handleCancel} size="large" className="px-6">
                  Hủy
                </Button>
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  onClick={handleSubmit}
                  size="large"
                  className="bg-blue-500 px-6"
                >
                  Lưu
                </Button>
              </div>
            </Form>
          </div>
        )}

        <p className="text-gray-500 mt-4">
          Hiển thị {listChatbot.length} / {listChatbot.length} chatbot
        </p>

        <Table
          columns={columns}
          dataSource={listChatbot.filter(
            (item) =>
              item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              item.name_model?.toLowerCase().includes(searchTerm.toLowerCase())
          )}
          rowKey="id"
          loading={loading}
          pagination={false}
          bordered
        />
      </div>
    </Layout>
  );
};

export default ChatbotManager;
